module.exports = __webpack_public_path__ + "img/album18_14.a59483b6.jpg";